import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IStaticPagesState } from './types';

export const SLICE_NAMESPACE = 'static-pages';

export const initialState: IStaticPagesState = {
  filters: {},
  sectionList: {
    data: [],
    isLoading: false,
    pagination: DEFAULT_PAGINATION,
  },
  form: {
    success: false,
    loading: false,
  },
};
